let suppressNext = false;

/**
 * Call right before a `history.pushState` that only updates the URL for
 * bookmarking/SEO purposes (e.g. "load more" pagination) without an actual
 * page navigation. Prevents SkipLink from stealing focus back to <body>,
 * which it otherwise does on every pathname change.
 */
export const suppressNextSkipLinkFocusReset = () => {
  suppressNext = true;
};

export const consumeSkipLinkFocusResetSuppression = () => {
  const shouldSuppress = suppressNext;
  suppressNext = false;
  return shouldSuppress;
};
